export default __webpack_public_path__ + "static/media/lidar-thumbnail.e1bd26db.jpg";